import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Branding } from './branding';
import { Page } from './types';
import { Box } from '@mui/material';
import { Account } from './account';
import MobileNavigation from './header/mobile/MobileNavigation';
import { MobileBranding } from './header/mobile/MobileBranding';
import { Navigation } from './navigation';
import { useAuth } from '@client/features/auth/auth.hook';
import { usePath } from './use-path';
import { useObservable } from '@client/foundation/shared/utils/observable.hook';
import { getWorkspaceFullscreen$ } from '@client/widgets/layouts/workspace-fullscreen.service';
import { colorTokens } from '@client/foundation/design-system/tokens';

const pages: Page[] = [
  // { title: "Dashboard", path: "/" },
  {
    title: 'Backtesting',
    path: '/backtesting'
  },
  {
    title: 'Live Trading',
    path: '/live-trading'
  },
  {
    title: 'Templates',
    path: '/templates'
  }
];

const unauthenticatedPages: Page[] = [
  {
    title: 'Login',
    path: '/login'
  },
  {
    title: 'Signup',
    path: '/signup'
  }
];

export const Header = () => {
  const { isAuthenticated } = useAuth();
  const { path } = usePath();
  const workspaceFullscreen = useObservable(() => getWorkspaceFullscreen$(), false);
  const isWorkspaceRoute = path === '/live-trading' || path === '/backtesting';

  if (isWorkspaceRoute && workspaceFullscreen) {
    return null;
  }

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        backgroundColor: colorTokens.slate950Alpha95,
        borderBottom: (theme) =>
          `1px solid ${theme.designSystem.surface.headerDivider}`,
        boxShadow: 'none',
        backdropFilter: 'blur(10px)',
        WebkitBackdropFilter: 'blur(10px)'
      }}
    >
      <Box sx={{ px: { xs: 1.5, md: 2 } }}>
        <Toolbar disableGutters sx={{ minHeight: 56 }}>
          <Branding />
          <MobileNavigation
            pages={isAuthenticated ? pages : unauthenticatedPages}
          />
          <MobileBranding />
          <Navigation pages={isAuthenticated ? pages : unauthenticatedPages} />
          {isAuthenticated && <Account />}
        </Toolbar>
      </Box>
    </AppBar>
  );
};
